import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'outlaw-count-badge',
  template: `
    <div class="badge" [class.badge--multi]="isMultiDigit()">
      <span class="badge__text">{{ count() }}</span>
    </div>
  `,
  styleUrl: './count-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountBadgeComponent {
  count = input.required<number>();

  isMultiDigit = computed(() => this.count() >= 10);
}
